import type { AxiosError } from "axios"
import axios from "axios"
import axiosRetry, { exponentialDelay, isNetworkError, isRetryableError } from "axios-retry"
import { debounce } from "underscore"
import { initAuth } from "./auth"
import serializeQueryParams from "./serialize-query-params"

const api = axios.create({
    baseURL: "/api",
    timeout: 30_000,
    paramsSerializer: {
        serialize: serializeQueryParams,
    },
})
axiosRetry(api, {
    retries: 3,
    retryDelay: exponentialDelay,
    retryCondition: (err) => isRetryableError(err) || isNetworkError(err), // retry all HTTP methods
})

const handleUnauthorized = debounce(
    () => {
        initAuth(api)
    },
    3000,
    true,
)

api.interceptors.request.use((config) => {
    return config
})

api.interceptors.response.use(
    (resp) => resp,
    (error: AxiosError) => {
        if (error.response?.status === 401) {
            handleUnauthorized()
        }
        throw error
    },
)

export default api
